import React from "react";
import { Offcanvas } from "react-bootstrap";
import AdminNavList from "./AdminNavList";

const AdminOffCanvasSidebar = ({ show, handleClose }) => {
	return (
		<Offcanvas
			show={show}
			onHide={handleClose}
			placement="start"
			className="admin-offcanvas"
		>
			<Offcanvas.Header closeButton>
				<Offcanvas.Title>Admin Menu</Offcanvas.Title>
			</Offcanvas.Header>
			<Offcanvas.Body>
				<AdminNavList onNavigate={handleClose} />
			</Offcanvas.Body>
		</Offcanvas>
	);
};

export default AdminOffCanvasSidebar;
